import React from 'react';
import { FormattedText } from 'core/i18n';
import { CreditCardInfo } from './CreditCardInfo/CreditCardInfo';
import { ProductsInformation } from '../ProductsInformation/ProductsInformation';
import { LegalIndex } from './LegalIndex/LegalIndex';
import { LegalInfoByCountry } from '../LegalInfoByCountry/LegalInfoByCountry';
import { DOCUMENTATION_LEGAL_INFO_BY_COUNTRY } from './constants';

const { LEGAL_INFO, LEGAL_INFO_BY_COUNTRY } = DOCUMENTATION_LEGAL_INFO_BY_COUNTRY;

export const Documentation = ({ getPartnerId, isCreditCard, productsInfo }) => {
    if (isCreditCard) return <CreditCardInfo getPartnerId={getPartnerId} />;

    return (
        <>
            <LegalIndex productsInfo={productsInfo} />
            <FormattedText value="documentation-gdprLegalInfo" injectedStrings={['1', '2']} />
            <FormattedText value="documentation-precontractualInformation" injectedStrings={['3']} />
            <ProductsInformation productsInfo={productsInfo} />
            <LegalInfoByCountry legalInfo={LEGAL_INFO} legalInfoByCountry={LEGAL_INFO_BY_COUNTRY} />
        </>
    );
};
